import { DependentsAction } from "../../types/contexts/dependentContext2/dependentAction.types";
import { Store } from "../../types/contexts/dependentContext2/store.types";
import actions from "./actions";

const reducer = (state: Store, action: DependentsAction): Store => {
	switch (action.type) {
		case actions.SET_DEPENDENT: {
			return {
				...state,
				dependent: action.payload
			};
		}
		default:
			throw new Error("Unexpected action: Auth Context");
	}
};

export default reducer;
